import { render, staticRenderFns } from "./zfblist.vue?vue&type=template&id=0df65b5e&scoped=true"
import script from "./zfblist.vue?vue&type=script&lang=js"
export * from "./zfblist.vue?vue&type=script&lang=js"
import style0 from "./zfblist.vue?vue&type=style&index=0&id=0df65b5e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0df65b5e",
  null
  
)

export default component.exports